import { render } from "./UserSettingView.vue?vue&type=template&id=3b777d50&scoped=true"
import script from "./UserSettingView.vue?vue&type=script&lang=js"
export * from "./UserSettingView.vue?vue&type=script&lang=js"

import "./UserSettingView.vue?vue&type=style&index=0&id=3b777d50&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b777d50"]])

export default __exports__